/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Login.css';

async function loginUser(credentials) {
    return fetch(process.env.REACT_APP_API_URL + '/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(credentials)
    })
      .then(data => data.json())
      .catch(function() {
        return false;
    });
}

export default function Login({ setToken, setRole }) {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [error, setError] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    const login = await loginUser({
      email,
      password
    });
    if (!login) {
        setError(true)
        return
    }
    setToken(login.token);
    setRole(login.role);
    const from = new URL(window.location.href).searchParams.get('from')
    if (from) {
        window.location.replace(from);
    }

  }

  return(
    <div id="login" className="uk-text-center uk-margin-auto" uk-grid="">
      <div className="uk-width-1-1@s uk-width-1-2@m uk-margin-auto uk-padding-remove uk-card uk-card-default">
        <div className="uk-card-header">
          <img alt="logo" src={process.env.PUBLIC_URL + '/medpb-logo.svg'} />
        </div>
        {error ? <div className="uk-alert-danger" uk-alert="">
          <a className="uk-alert-close" uk-close=""></a>
          <p>Login error!</p>
        </div> : null}
        <form onSubmit={handleSubmit} className="uk-card-body">
          <fieldset className="uk-fieldset">

              <div className="uk-margin">
                <input className="uk-input" type="email" placeholder="Email" name="email" onChange={e => setEmail(e.target.value)}/>
              </div>

              <div className="uk-margin">
                <input className="uk-input" type="password" placeholder="Password" name="password" onChange={e => setPassword(e.target.value)}/>
              </div>

              <button className="uk-button uk-button-default" type="submit">Login <span uk-icon="sign-in"></span></button>

          </fieldset>
        </form>
      </div>
    </div>
  )
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
};